import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { ETransactionType } from 'src/types'

export const defaultPage = 0
export const defaultLimit = 50
export const defaultSort = 'log.created_at-desc'

export const txLogsSortOptions = [
  {
    label: 'sort-value-asc.v',
    value: 'log.explorer_url-asc',
  },
  {
    label: 'sort-value-desc.v',
    value: 'log.explorer_url-desc',
  },
  {
    label: 'sort-email-asc.v',
    value: 'user.email-asc',
  },
  {
    label: 'sort-email-desc.v',
    value: 'user.email-desc',
  },
  {
    label: 'sort-account-name-asc.v',
    value: 'account.account_holder-asc',
  },
  {
    label: 'sort-account-name-desc.v',
    value: 'account.account_holder-desc',
  },
  {
    label: 'sort-created-desc.v',
    value: 'log.created_at-desc',
  },
  {
    label: 'sort-created-asc.v',
    value: 'log.created_at-asc',
  },
]

const txLogSelectValues: ISortSelectOption[] = [
  {
    label: 'all',
    value: 'all',
  },
  {
    label: 'Consumer Scan',
    value: ETransactionType.ConsumerScan,
  },
  {
    label: 'Scan',
    value: ETransactionType.Scan,
  },
  {
    label: 'Account NFT',
    value: ETransactionType.AccountToken,
  },
  {
    label: 'Product NFT',
    value: ETransactionType.ProductToken,
  },
  {
    label: 'Arweave',
    value: ETransactionType.Arweave,
  },
]

export const txLogSelectionOptions = {
  selectName: 'transaction-type-label.v',
  queryParamName: 'type',
  items: txLogSelectValues,
}
